import React from "react"
import classNames from "classnames"
import {FeatureItem} from "../../FeatureItemCard/types"
import {ReadyToLaunchCard} from "../../../containers/ReadyToLaunchCard/ReadyToLaunchCard"
import {FeatureItemCard} from "../../FeatureItemCard/FeatureItemCard"
import {compact} from "lodash"

interface FeaturesCardProps {
	features: FeatureItem[]
	className?: string
}

export function FeaturesCard({features, className}: FeaturesCardProps) {
	const notes = compact(features.map((feature) => feature.note))

	return (
		<ReadyToLaunchCard title="Features" className={classNames("features-card", className)}>
			<div className="columns is-multiline">
				{features.map((feature) => (
					<div key={feature.title} className="column is-one-third">
						<FeatureItemCard {...feature} />
					</div>
				))}
			</div>

			{notes.length > 0 && (
				<div className="features-card-notes">
					<ol className="features-card-notes-list">
						{notes.map(({id, description}, index) => (
							<React.Fragment key={id}>
								{index > 0 && <hr className="features-card-note-divider" />}
								<li className="features-card-note-item">
									<sup>{id}</sup> {description}
								</li>
							</React.Fragment>
						))}
					</ol>
				</div>
			)}
		</ReadyToLaunchCard>
	)
}
